export const loginFormTranslationsPl = {
    loginFormSignIn: 'Zaloguj się',
    loginFormTitle: 'TSR BackOffice',
    invalidRedirect: 'Błąd z połączeniem',
    msalInstanceNotInitialized: 'Błąd podczas inicializacji aplikacji',
};

export const loginFormTranslationsEn = {
    loginFormSignIn: 'Sign In',
    loginFormTitle: 'TSR BackOffice',
    invalidRedirect: 'Error occured',
    msalInstanceNotInitialized: 'Initialization error',
};
